module.exports = __webpack_public_path__ + "static/media/message.fd3d85fd.png";